import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {HttpRequestErrorHandler, HttpUtils, RequestResponse} from '@rbaip/ui-component';
import {catchError, map} from 'rxjs/operators';
import {Observable} from 'rxjs';
import {DealerDismantlerReasonModel} from './dealer-dismantler-reason.model';
import {ItemAuctionInfo} from './item-auction-info.model';

@Injectable({
  providedIn: 'root'
})
export class ItemAuctionService {

  constructor(private http: HttpClient) {
  }

  public getItemAuctionInfo(equipId: number): Observable<ItemAuctionInfo> {
    const url = `/api/equipment/${equipId}/auction`;
    return this.http.get<ItemAuctionInfo>(url, HttpUtils.jsonHttpOptions)
      .pipe(
        catchError(HttpRequestErrorHandler.handleError('Auction Info', null, false, {refreshPageWhenTimedOut: true})),
        map(response => {
          return ItemAuctionInfo.fromJson(response.data);
        })
      );
  }

  public updateAuctionSellingMethodInfo(itemAuctionInfo: ItemAuctionInfo): Observable<RequestResponse> {
    const url = `/api/equipment/${itemAuctionInfo.equipId}/auction/selling-method`;
    const body = JSON.stringify(itemAuctionInfo);
    return this.http.put<RequestResponse>(url, body, HttpUtils.jsonHttpOptions).pipe(
      catchError(HttpRequestErrorHandler.handleError('Selling Method', null, false, {refreshPageWhenTimedOut: true}))
    );
  }

  public findDismantlerReasonList(): Observable<RequestResponse> {
    const url = `/api/auctions/dealer-dismantler-reasons`;
    return this.http.get<RequestResponse>(url, HttpUtils.jsonHttpOptions)
      .pipe(
        catchError(HttpRequestErrorHandler.handleError('Dealer Dismantler Reason', null, false, {refreshPageWhenTimedOut: true}))
      );
  }

  public addOtherReason(reason: string): Observable<RequestResponse> {
    const url = `/api/auctions/dealer-dismantler-reasons`;
    const body = JSON.stringify({
      description: reason
    });
    return this.http.post(url, body, HttpUtils.jsonHttpOptions)
      .pipe(
        catchError(HttpRequestErrorHandler.handleError('Add Other Reason', null, false, {refreshPageWhenTimedOut: true}))
      );
  }

  public saveSaleByUnitInfo(itemAuctionInfo: ItemAuctionInfo): Observable<RequestResponse> {
    const url = `/api/equipment/${itemAuctionInfo.equipId}/auction/sale-by-unit`;
    const body = JSON.stringify(itemAuctionInfo);
    return this.http.post<RequestResponse>(url, body, HttpUtils.jsonHttpOptions)
      .pipe(
        catchError(HttpRequestErrorHandler.handleError('Sale By Unit', null, false, {refreshPageWhenTimedOut: true}))
      );
  }
}
